import { render, staticRenderFns } from "./seo.vue?vue&type=template&id=4155a7eb"
import script from "./seo.vue?vue&type=script&lang=js"
export * from "./seo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports